export type PaginationPageItem =
  | { type: 'page'; value: number }
  | { type: 'ellipsis'; key: string }

export const DEFAULT_PAGINATION_PAGE_SIZE_OPTIONS = [10, 25, 50, 100] as const

export const buildPaginationItems = (
  currentPage: number,
  totalPages: number,
): PaginationPageItem[] => {
  const total = Math.max(totalPages, 1)
  const current = Math.min(Math.max(currentPage, 1), total)

  if (total <= 7) {
    return Array.from({ length: total }, (_, index) => ({
      type: 'page' as const,
      value: index + 1,
    }))
  }

  if (current <= 3) {
    return [
      { type: 'page', value: 1 },
      { type: 'page', value: 2 },
      { type: 'page', value: 3 },
    ]
  }

  if (current >= total - 2) {
    return [
      { type: 'page', value: 1 },
      { type: 'page', value: 2 },
      { type: 'page', value: 3 },
      { type: 'ellipsis', key: 'end-gap' },
      { type: 'page', value: total - 2 },
      { type: 'page', value: total - 1 },
      { type: 'page', value: total },
    ]
  }

  return [
    { type: 'page', value: 1 },
    { type: 'ellipsis', key: 'start-gap' },
    { type: 'page', value: current - 1 },
    { type: 'page', value: current },
    { type: 'page', value: current + 1 },
    { type: 'ellipsis', key: 'end-gap' },
    { type: 'page', value: total },
  ]
}

export const formatPaginationPageSizeLabel = (pageSize: number): string =>
  `${pageSize} results/page`
